<p-autoComplete class="w-full"
[(ngModel)]="selectedTrip" 
[suggestions]="dropdownItems" 
[dropdown]="true" 
[forceSelection]="true"
placeholder="Select a Trip" 
(completeMethod)="search($event)"
[completeOnFocus]="true"
(onSelect)="onTripSelected($event)"
[readonly]="readonly"
(onClear)="onTripClear()"
[disabled]="disabled"
optionLabel="fullText"
inputStyleClass="w-full"
appendTo="body"
[pTooltip]="showTooltip ? (selectedTrip?.fullText ?? '') : ''"
[delay]="300"
(onBlur)="onInputBlur()"

>

</p-autoComplete>
